// extracted by mini-css-extract-plugin
module.exports = {"user-profile-icon":"_3Rxqt"};